site.nav = {
	selector: '#mobilemenu',
	desktopSelector: '#mainmenu',

	init: function () {
		site.nav.cloneMenu();
		site.nav.bind();
		//site.nav.prependSearchBox();
		//site.nav.appendLanguage();
		site.nav.prependHeader();
		site.nav.appendQuickNav();
	},

	cloneMenu: function () {
		var $target = $('#mainmenu'),
			selector = site.nav.selector.substr(1),
			$html = $('<div id="' + selector + '" role="navigation"></div>'),
			$menu = $target.find('.mmLevel1').clone().removeAttr('id');
		$menu.find('ul').removeAttr('id');
		$html.append($menu);
		$html.insertAfter($target.parent());
	},

	bind: function () {
		// Add expand link to mobile menu
		$('<button class="expand" aria-label="Opna/loka"></button>')
			.insertAfter('#mobilemenu .children > a, #mobilemenu .children > div');
		$('li[class*="selectedLevel"]', site.nav.selector).addClass('down');

		// Mobile menu toggle
		$('#mainmenuToggle').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mobilemenu-open');
			site.nav.mobileToggle(e, menuOpen);
			if (!menuOpen) {
				$(this).attr('aria-expanded', true);
			}
			else {
				$(this).removeAttr('aria-expanded');
			}

			$(site.nav.selector).on('click touchstart', function (e) {
				e.stopPropagation();
			});
			$(site.nav.desktopSelector).on('click touchstart', function (e) {
				e.stopPropagation();
			});

			$('body.mobilemenu-open').on('click touchstart', function (e) {
				$('body').removeClass('mobilemenu-open');
				site.nav.closeMenu();
			});
		});

		// Expand in mobile menu
		$('.expand', site.nav.selector).bind('click touchstart', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('li').toggleClass('down');
		});
	},
	// Toggle mobile menu
	mobileToggle: function (e, menuOpen) {
		$('body').toggleClass('mobilemenu-open');

		if (menuOpen) {
			site.nav.closeMenu();
		}
	},

	closeMenu: function() {
		var $body = $('body');
		if ($body.hasClass('mobilemenu-open')) {
			$body.addClass('mobilemenu-closing')
			setTimeout(function() {
				$('body').removeClass('mobilemenu-closing');
			},300);
		}
	},

	// Append language to site
	appendLanguage: function () {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', site.nav.selector);

		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$li.addClass('ele-language level1');
			$menu.append($li);
		});
	},

	appendQuickNav: function () {
		var $qn = $('#qn');
		var $menu = $('ul.mmLevel1', site.nav.selector);
		var $qnContent = '';

		$qn.find('.right').each(function () {
			$qnContent += '<div class="qn mobileQn">' + $(this).clone().html() + '</div>';
		});
		$menu.append($qnContent);
	},

	prependSearchBox: function () {
		var $mainmenu = $(site.nav.selector),
			$mSearchBox = $('#searchBox').clone().removeAttr('id').attr('id', 'mSearchBox');
		$mainmenu.prepend($mSearchBox);

		$('[id]', $mSearchBox).each(function () {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm' + $id.substr(0, 1).toUpperCase() + $id.substr(1),
				$label = $('label[for="' + $id + '"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);
		});
	},

	prependHeader: function() {
		$('.mmLevel1 ul', site.nav.selector).each(function() {
			var $title = $(this).closest('li').find('>a, > div').clone();
			$title.addClass('back');
			$(this).prepend($title);
		});
		$('.back', site.nav.selector).wrap('<li class="header">');
		$('div.back', site.nav.selector).wrapInner('<a href="#" class="back">');
		$('div.back a.back', site.nav.selector).unwrap();

		$('a.back', site.nav.selector).on('click', function(e) {
			e.preventDefault();
			$(this).closest('li.down').removeClass('down');
		});
	}
};
